import * as React from 'react';

export function CustomerCareSection() {
  return (
    <section className="whyus-care">
      <style>{`
        .whyus-care {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .whyus-care-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-care h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .whyus-care .subtitle {
          font-size: 16px;
          color: #666;
          margin: 0 0 32px;
        }
        .whyus-checklist {
          list-style: none;
          padding: 0;
          margin: 0 0 28px;
        }
        .whyus-checklist li {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          border-radius: 10px;
          margin-bottom: 8px;
          background: #f0fdf0;
        }
        .whyus-checklist li i {
          color: #1EAA25;
          font-size: 18px;
          flex-shrink: 0;
        }
        .whyus-care .closing {
          font-size: 16px;
          color: #555;
          margin: 0;
        }
        .whyus-care .closing a {
          color: #1EAA25;
          font-weight: 600;
          text-decoration: none;
        }
        .whyus-care .closing a:hover {
          text-decoration: underline;
        }
        @media (max-width: 640px) {
          .whyus-care h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-care-inner">
        <h2>Si algo sale mal, lo resolvemos. Sin vueltas.</h2>
        <p className="subtitle">No escondemos las políticas en letra chica.</p>
        <ul className="whyus-checklist">
          <li><i className="fa fa-check-circle" /> Reposición sin costo si el producto no cumple nuestro estándar</li>
          <li><i className="fa fa-check-circle" /> Reembolso transparente y rápido</li>
          <li><i className="fa fa-check-circle" /> Atención humana y personalizada</li>
          <li><i className="fa fa-check-circle" /> Canales de contacto directos: chat, WhatsApp, email</li>
          <li><i className="fa fa-check-circle" /> Pagá con MercadoPago, tarjeta o transferencia — no ahorramos en comisiones a costa de tu comodidad</li>
        </ul>
        <p className="closing">
          <a href="/politicas">Conocé nuestras políticas →</a>
        </p>
      </div>
    </section>
  );
}
